import map from "lodash/fp/map";
import flow from "lodash/fp/flow";
import each from "lodash/fp/each";
import cloneDeep from "lodash/fp/cloneDeep";

import { toObject } from "../../core/utils";
import constants from "../../core/constants";

class FulfillmentPlanPageTransform {
  constructor() {
    "ngInject";

    this.deductionTypes = [
      { title: "Percentage (%)", name: "percentage" },
      { title: "Fixed", name: "fixed" },
    ];
  }

  justify(data, deductionReasons) {
    this.justifyRulesResponse(data.rules, deductionReasons);

    return toObject(data);
  }

  justifyRulesResponse(data, deductionReasons) {
    const formatAmount = (item) => {
      item.amount =
        item.type === "fixed"
          ? item.amount / constants.currencyBy
          : item.amount * 100; // Percentage

      return item;
    };

    const formatType = (item) => {
      item.type = this.deductionTypes.find((type) => type.name === item.type);

      return item;
    };

    const formatReasons = (item) => {
      item.reasons = deductionReasons.filter((reason) =>
        item.reasons.includes(reason.key)
      );
    };

    each(flow([formatAmount, formatType, formatReasons]))(data);
  }

  justifyRulesRequest(data) {
    const clonedData = cloneDeep(data);

    const formatRule = (item) => {
      delete item.new;

      return item;
    };

    const formatAmount = (item) => {
      item.amount =
        item.type === "fixed"
          ? item.amount * constants.currencyBy
          : item.amount / 100; // Percentage
      item.time_before_ride = item.time_before_ride || 0;

      return item;
    };

    const formatType = (item) => {
      item.type = item.type.name;

      return item;
    };

    const formatReasons = (item) => {
      item.reasons = item.reasons.map((reason) => reason.key);

      return item;
    };

    return map(flow([formatRule, formatType, formatAmount, formatReasons]))(
      clonedData
    );
  }
}

export default FulfillmentPlanPageTransform;



// WEBPACK FOOTER //
// ./src/pages/fulfillmentPlan/fulfillmentPlan.transforms.js